/**
 * @generated SignedSource<<2f63a21a3e815d13a7555b6d13c672f9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserStatus = "ACTIVE" | "APPEAL" | "BANNED" | "BANNED_PERMANENT" | "INACTIVE" | "PENDING" | "SCHEDULED_FOR_DELETION" | "%future added value";
export type MatchProfileScreenQuery$variables = {
  matchId: any;
};
export type MatchProfileScreenQuery$data = {
  readonly match: {
    readonly profile: {
      readonly rowId: any;
      readonly user: {
        readonly status: UserStatus;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"MatchProfileView_match">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"MatchProfileView_query">;
};
export type MatchProfileScreenQuery = {
  response: MatchProfileScreenQuery$data;
  variables: MatchProfileScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "matchId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rowId",
    "variableName": "matchId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "StorageObject",
  "kind": "LinkedField",
  "name": "storageObject",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blurhash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bucket",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": {
        "equalTo": "PROFILE"
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v8 = [
  (v6/*:: as any*/),
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchProfileScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Match",
        "kind": "LinkedField",
        "name": "match",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchProfileView_match"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "MatchProfileView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "MatchProfileScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Match",
        "kind": "LinkedField",
        "name": "match",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserDeetConnection",
                    "kind": "LinkedField",
                    "name": "userDeets",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserDeet",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deetId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "other",
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "UserPromptConnection",
                    "kind": "LinkedField",
                    "name": "userPrompts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserPrompt",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "answer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Prompt",
                            "kind": "LinkedField",
                            "name": "prompt",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "question",
                                "storageKey": null
                              },
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userPrompts(orderBy:[\"SEQUENCE_ASC\"])"
                  }
                ],
                "storageKey": null
              },
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "headshot",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "age",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closestCity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "distanceInKilometers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "distanceInMiles",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagram",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVerified",
                "storageKey": null
              },
              {
                "alias": "profilePhotos",
                "args": (v7/*:: as any*/),
                "concreteType": "PhotoConnection",
                "kind": "LinkedField",
                "name": "photos",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhotoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Photo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sequence",
                            "storageKey": null
                          },
                          (v5/*:: as any*/),
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "photos(filter:{\"type\":{\"equalTo\":\"PROFILE\"}},first:10)"
              },
              {
                "alias": "profilePhotos",
                "args": (v7/*:: as any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "useProfilePhotos_profile_profilePhotos",
                "kind": "LinkedHandle",
                "name": "photos"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "activities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v8/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BeliefSystem",
                "kind": "LinkedField",
                "name": "beliefSystem",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "biography",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChildrenPreference",
                "kind": "LinkedField",
                "name": "childrenPreference",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DeetConnection",
                "kind": "LinkedField",
                "name": "deets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Deet",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isOther",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EducationLevel",
                "kind": "LinkedField",
                "name": "educationLevel",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Gender",
                "kind": "LinkedField",
                "name": "gender",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genderOther",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightCm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightFt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occupation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticalView",
                "kind": "LinkedField",
                "name": "politicalView",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Pronoun",
                "kind": "LinkedField",
                "name": "pronoun",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RelationshipTypeConnection",
                "kind": "LinkedField",
                "name": "relationshipInterests",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RelationshipType",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v8/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "school",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VaccinationStatus",
                "kind": "LinkedField",
                "name": "vaccinationStatus",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verificationRequested",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewedAt",
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unviewedMatchesCount",
            "storageKey": null
          },
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentUserUnreadCount",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b777339a6bf7b8720d06550daab0430",
    "id": null,
    "metadata": {},
    "name": "MatchProfileScreenQuery",
    "operationKind": "query",
    "text": "query MatchProfileScreenQuery(\n  $matchId: UUID!\n) {\n  match(rowId: $matchId) {\n    profile {\n      rowId\n      user {\n        status\n        id\n      }\n      id\n    }\n    ...MatchProfileView_match\n    id\n  }\n  ...MatchProfileView_query\n}\n\nfragment MatchProfileView_match on Match {\n  profile {\n    rowId\n    ...ProfileAvatar_profile\n    ...ProfileBlockButton_profile\n    ...ProfileCard_profile\n    ...ProfileHeaderTitle_profile\n    ...ProfileInfo_profile\n    ...ProfileReportButton_profile\n    ...ProfileVerificationButton_profile\n    ...ProfileVerifiedBadge_profile\n    id\n  }\n  rowId\n  toUserId\n  viewedAt\n  ...ProfileUnmatchButton_match\n}\n\nfragment MatchProfileView_query on Query {\n  currentUser {\n    rowId\n    unviewedMatchesCount\n    id\n  }\n  currentUserUnreadCount\n  ...ProfileCard_query\n  ...ProfileInfo_query\n}\n\nfragment ProfileAvatar_profile on Profile {\n  headshot {\n    storageObject {\n      blurhash\n      bucket\n      key\n    }\n    id\n  }\n  name\n}\n\nfragment ProfileBlockButton_profile on Profile {\n  name\n  userId\n}\n\nfragment ProfileCard_profile on Profile {\n  age\n  closestCity\n  distanceInKilometers\n  distanceInMiles\n  instagram\n  isVerified\n  name\n  rowId\n  userId\n  ...ProfileVerifiedBadge_profile\n  ...useProfilePhotos_profile\n}\n\nfragment ProfileCard_query on Query {\n  currentUser {\n    isMetricSystem\n    rowId\n    id\n  }\n}\n\nfragment ProfileHeaderTitle_profile on Profile {\n  age\n  closestCity\n  name\n  isVerified\n  ...ProfileAvatar_profile\n}\n\nfragment ProfileInfo_profile on Profile {\n  activities {\n    nodes {\n      name\n      id\n    }\n  }\n  age\n  beliefSystem {\n    name\n    id\n  }\n  biography\n  childrenPreference {\n    name\n    id\n  }\n  closestCity\n  deets {\n    nodes {\n      rowId\n      name\n      isOther\n      id\n    }\n  }\n  educationLevel {\n    name\n    id\n  }\n  gender {\n    name\n    id\n  }\n  genderOther\n  heightCm\n  heightFt\n  heightIn\n  occupation\n  politicalView {\n    name\n    id\n  }\n  pronoun {\n    name\n    id\n  }\n  relationshipInterests {\n    nodes {\n      name\n      id\n    }\n  }\n  school\n  userId\n  user {\n    userDeets {\n      nodes {\n        deetId\n        other\n        id\n      }\n    }\n    userPrompts(orderBy: [SEQUENCE_ASC]) {\n      nodes {\n        answer\n        prompt {\n          question\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n  vaccinationStatus {\n    name\n    id\n  }\n}\n\nfragment ProfileInfo_query on Query {\n  currentUser {\n    isMetricSystem\n    id\n  }\n}\n\nfragment ProfileReportButton_profile on Profile {\n  name\n  userId\n}\n\nfragment ProfileUnmatchButton_match on Match {\n  profile {\n    name\n    id\n  }\n  rowId\n}\n\nfragment ProfileVerificationButton_profile on Profile {\n  isVerified\n  name\n  userId\n  verificationRequested\n}\n\nfragment ProfileVerifiedBadge_profile on Profile {\n  isVerified\n}\n\nfragment useProfilePhotos_profile on Profile {\n  profilePhotos: photos(first: 10, filter: {type: {equalTo: PROFILE}}) {\n    edges {\n      cursor\n      node {\n        description\n        rowId\n        sequence\n        storageObject {\n          blurhash\n          bucket\n          key\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "b7f6368ccb96ed97b2cff68eceab2fa0";

export default node;
